export function filterTypeSpecifications(schema, filter) {
    const items = [];
    if (filter.showEntityTypes) {
        items.push(...filterItems(schema.spec.entityTypes, filter.entityTypes));
    }
    if (filter.showComponentTypes) {
        items.push(...filterItems(schema.spec.componentTypes, filter.componentTypes));
    }
    return items;
}
function filterItems(items, filterNames) {
    let types = items;
    if (filterNames && filterNames.length > 0) {
        types = types.filter((it) => filterNames.indexOf(it.name) >= 0);
    }
    return types;
}
//# sourceMappingURL=TypeSelectionUtils.js.map